// extracted by mini-css-extract-plugin
export default {"table_container":"src-components-CommonTable-index-module_table_container--U6eXF"};